<template>
    <defaultSec :returnState="true">
        <template #title>
            <div  class="default-header" style="display: flex;justify-content: space-between">
                <h3 v-if="editAble" style="cursor: pointer" @click="returnPage">< 舆情详情</h3>
                <h3 v-else style="cursor: pointer">舆情详情</h3>
                <div>
                    <el-button style="float: right; padding: 5px 10px" type="danger" @click="publicSentimentSubmit">保存舆情</el-button>
                </div>

            </div>

        </template>
        <div class="public-sentiment-detail" v-loading="loading">
            <el-tabs type="border-card">
                <el-tab-pane label="舆情信息">
                    <div class="scroll-tab-wrap">

                        <el-alert style="margin: 10px 0"
                                  title="基本信息"
                                  type="success"
                                  :closable="false">
                        </el-alert>
                        <el-descriptions class="margin-top" :label-style="labelStyle" :column="1" size="small" border>

                            <el-descriptions-item>
                                <template slot="label">
                                    <span style="color: #e50011">*</span> 舆情来源
                                </template>
                                <el-select filterable :disabled="!editAble?true:false" size="small" style="width: 100%" v-model="publicSentimentInfo.source" placeholder="请选择">
                                    <el-option
                                        v-for="item in dictionaryList.source||[]"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    <span style="color: #e50011">*</span> 短链接
                                </template>
                                <el-input :disabled="sentimentId!=0?true:false" size="small" v-model="publicSentimentInfo.shortUrl" placeholder="请输入" >
                                    <el-button :loading="XhsLoading" slot="append" type="success" icon="el-icon-search" @click="getShortDetail">获取详细内容</el-button>
                                </el-input>
                            </el-descriptions-item>

                        </el-descriptions>
                        <el-alert style="margin: 20px 0 10px 0"
                                  title="详细内容（通过短链接获取）"
                                  type="success"
                                  :closable="false">
                        </el-alert>
                        <template v-if="publicSentimentInfo.hasOwnProperty('account')">
                            <el-descriptions class="margin-top" :label-style="labelStyle" :column="1" size="small" border>
                                <el-descriptions-item label="用户头像">
                                    <el-avatar size="small" icon="el-icon-user-solid" :src="publicSentimentInfo.userImage"></el-avatar>
                                </el-descriptions-item>
                                <el-descriptions-item label="用户名称">
                                    {{publicSentimentInfo.userName}}
                                </el-descriptions-item>
                                <el-descriptions-item label="用户账号">
                                    {{publicSentimentInfo.account}}
                                </el-descriptions-item>
                                <el-descriptions-item label="IP属地">
                                    {{publicSentimentInfo.address}}
                                </el-descriptions-item>
                                <el-descriptions-item label="粉丝数量">
                                    {{publicSentimentInfo.fansCount}}
                                </el-descriptions-item>
                                <el-descriptions-item label="发布时间">
                                    {{publicSentimentInfo.publishTime}}
                                </el-descriptions-item>
                                <el-descriptions-item label="笔记标题">
                                    <div class="img-div" v-html="publicSentimentInfo.noteTitle"></div>
                                </el-descriptions-item>
                                <el-descriptions-item label="笔记内容">
                                    <div class="img-div" v-html="publicSentimentInfo.noteContent"></div>
                                </el-descriptions-item>
                                <el-descriptions-item label="图片地址">
                                    <el-image :src="url" fit="cover" style="width: 50px; height: 50px;margin-right: 5px" :preview-src-list="publicSentimentInfo.noteImage?publicSentimentInfo.noteImage.split(','):[]" v-for="(url,index) in publicSentimentInfo.noteImage?publicSentimentInfo.noteImage.split(','):[]">图片{{index+1}}</el-image>
                                </el-descriptions-item>
                                <el-descriptions-item label="视频地址">
                                    {{publicSentimentInfo.noteVideo}}
                                    <!--                                <video :src="publicSentimentInfo.noteVideo"></video>-->
                                </el-descriptions-item>
                                <el-descriptions-item label="评论数">
                                    {{publicSentimentInfo.commentCount}}
                                </el-descriptions-item>
                                <el-descriptions-item label="评论列表">
                                    <div style="max-height: 400px;overflow-y: scroll">
                                        <div class="comment-item" v-for="item in publicSentimentInfo.commentList">
                                            <el-avatar class="item-avatar" size="small" :src="item.avatar" icon="el-icon-user-solid"></el-avatar>
                                            <div class="item-wrap">
                                                <div>{{item.userName}}</div>
                                                <div class="item-content img-div" v-html="item.content"></div>
                                                <div>{{item.date}}</div>
                                                <div style="margin-bottom: 10px">
                                                    <span><i class="el-icon-star-off"></i> {{item.likeCount}}</span>
                                                    <span><i class="el-icon-chat-dot-round"></i>{{item.replyCount}}</span>
                                                </div>
                                                <div class="comment-item" v-for="item1 in item.replyList">
                                                    <el-avatar class="item-avatar" size="small" :src="item1.avatar" icon="el-icon-user-solid"></el-avatar>
                                                    <div class="item-wrap">
                                                        <div>{{item1.userName}}</div>
                                                        <div class="item-content img-div" v-html="item1.content"></div>
                                                        <div>{{item1.date}}</div>
                                                        <div>
                                                            <span><i class="el-icon-star-off"></i> {{item1.likeCount}}</span>
                                                            <span><i class="el-icon-chat-dot-round"></i>{{item1.replyCount}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </el-descriptions-item>
                                <el-descriptions-item label="点赞数">
                                    {{publicSentimentInfo.likeCount}}
                                </el-descriptions-item>
                                <el-descriptions-item label="收藏数">
                                    {{publicSentimentInfo.collectCount}}
                                </el-descriptions-item>
                                <el-descriptions-item label="链接">
                                    <el-button size="mini" @click="()=>openBlank(publicSentimentInfo.realUrl)" type="warning">打开链接</el-button>
                                </el-descriptions-item>
                            </el-descriptions>
                        </template>
                        <el-empty v-else :image-size="50">
                            <template slot="description">
                                <template v-if="XhsLoading">
                                    <el-button type="text" :loading="XhsLoading">加载中</el-button>
                                </template>
                                <template v-else>
                                    <span style="font-size: 12px;color: #209e91">暂无数据</span>
                                </template>
                            </template>
                        </el-empty>
                        <el-alert style="margin: 20px 0 10px 0"
                                  title="舆情用户诉求及处理"
                                  type="success"
                                  :closable="false">
                        </el-alert>
                        <el-descriptions class="margin-top" :label-style="labelStyle" :column="columnsCount" size="small" border>
                            <el-descriptions-item label="负责伙伴">
                                <el-select  clearable filterable style="width: 100%" v-model="publicSentimentInfo.chargePerson" placeholder="请选择">
                                    <el-option
                                        v-for="item in userList"
                                        :key="item.USER_NAME"
                                        :label="item.USER_NAME"
                                        :value="item.USER_NAME">
                                    </el-option>
                                </el-select>
                            </el-descriptions-item>
                            <el-descriptions-item label="反馈问题类型">
                                <el-select  clearable filterable :disabled="!editAble?true:false" size="small" style="width: 100%" v-model="publicSentimentInfo.questionType" placeholder="请选择">
                                    <el-option
                                        v-for="item in dictionaryList.questionType||[]"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-descriptions-item>
                            <el-descriptions-item label="反馈产品">
                                <el-input
                                    type="textarea" v-model="publicSentimentInfo.productName" placeholder="请输入" :rows="2"></el-input>
                            </el-descriptions-item>

                            <el-descriptions-item label="用户诉求">
                                <el-input
                                    type="textarea" v-model="publicSentimentInfo.userAppeal" placeholder="请输入" :rows="2"></el-input>
                            </el-descriptions-item>
                            <el-descriptions-item label="赔付和补偿方案">
                                <el-input
                                    type="textarea" v-model="publicSentimentInfo.solution" placeholder="请输入" :rows="2"></el-input>
                            </el-descriptions-item>
                            <el-descriptions-item label="投诉内容">
                                <el-input
                                    type="textarea" v-model="publicSentimentInfo.complaintContent" placeholder="请输入" :rows="2"></el-input>
                            </el-descriptions-item>
                            <el-descriptions-item label="备注">
                                <el-input
                                    type="textarea" v-model="publicSentimentInfo.remark" placeholder="请输入" :rows="2"></el-input>
                            </el-descriptions-item>
                            <!--                        <el-descriptions-item label="状态">-->
                            <!--                            <el-radio-group size="mini" v-model="publicSentimentInfo.status">-->
                            <!--                                <el-radio :label="1">有效</el-radio>-->
                            <!--                                <el-radio :label="0">已删除</el-radio>-->
                            <!--                            </el-radio-group>-->
                            <!--                        </el-descriptions-item>-->

                            <el-descriptions-item label="创建时间">
                                {{publicSentimentInfo.createTime||''}}
                            </el-descriptions-item>
                            <el-descriptions-item label="创建人">
                                {{publicSentimentInfo.createPerson||''}}
                            </el-descriptions-item>
                            <el-descriptions-item label="更新时间">
                                {{publicSentimentInfo.updateTime||''}}
                            </el-descriptions-item>
                            <el-descriptions-item label="更新人">
                                {{publicSentimentInfo.updatePerson||''}}
                            </el-descriptions-item>
                        </el-descriptions>
                        <el-alert style="margin: 20px 0 10px 0"
                                  title="舆情追踪"
                                  type="success"
                                  :closable="false">
                        </el-alert>
                        <el-descriptions class="margin-top" :label-style="{width: '160px',}" :column="1" size="small" border>
                            <el-descriptions-item label="笔记下面直接留言时间">
                                <el-date-picker size="small" v-model="publicSentimentInfo.noteMessageTime" type="date" placeholder="选择日期"
                                                value-format="yyyy-MM-dd"></el-date-picker>
                            </el-descriptions-item>
                            <el-descriptions-item label="笔记下面直接回复时间">
                                <el-date-picker size="small" v-model="publicSentimentInfo.noteReplyTime" type="date" placeholder="选择日期"
                                                value-format="yyyy-MM-dd"></el-date-picker>
                            </el-descriptions-item>
                            <el-descriptions-item label="私信联系时间">
                                <el-date-picker size="small" v-model="publicSentimentInfo.privateMessageTime" type="date" placeholder="选择日期"
                                                value-format="yyyy-MM-dd"></el-date-picker>
                            </el-descriptions-item>
                            <el-descriptions-item label="私信首次回复时间">
                                <el-date-picker size="small" v-model="publicSentimentInfo.privateFirstReplyTime" type="date" placeholder="选择日期"
                                                value-format="yyyy-MM-dd"></el-date-picker>
                            </el-descriptions-item>
                            <el-descriptions-item label="12小时后个人号联系时间">
                                <el-date-picker size="small" v-model="publicSentimentInfo.privateMessageHalfdayTime" type="date" placeholder="选择日期"
                                                value-format="yyyy-MM-dd"></el-date-picker>
                            </el-descriptions-item>
                            <el-descriptions-item label="12小时后个人号回复时间">
                                <el-date-picker size="small" v-model="publicSentimentInfo.privateFirstReplyHalfdayTime" type="date" placeholder="选择日期"
                                                value-format="yyyy-MM-dd"></el-date-picker>
                            </el-descriptions-item>
                            <el-descriptions-item label="24小时内未回复评论留言时间">
                                <el-date-picker size="small" v-model="publicSentimentInfo.privateFirstReplyDayTime" type="date" placeholder="选择日期"
                                                value-format="yyyy-MM-dd"></el-date-picker>
                            </el-descriptions-item>
                            <el-descriptions-item label="官方账号留言时间">
                                <el-date-picker size="small" v-model="publicSentimentInfo.officialAccountMessageTime" type="date" placeholder="选择日期"
                                                value-format="yyyy-MM-dd"></el-date-picker>
                            </el-descriptions-item>
                            <el-descriptions-item label="官方账号回复时间">
                                <el-date-picker size="small" v-model="publicSentimentInfo.officialAccountReplyTime" type="date" placeholder="选择日期"
                                                value-format="yyyy-MM-dd"></el-date-picker>
                            </el-descriptions-item>
                            <el-descriptions-item label="是否取得联系方式">
                                <el-select  clearable filterable :disabled="!editAble?true:false" size="small" style="width: 100%" v-model="publicSentimentInfo.isGetNumber" placeholder="请选择">
                                    <el-option
                                        v-for="item in dictionaryList.isGetNumber||[]"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-descriptions-item>
                            <el-descriptions-item label="获取到联系方式时间">
                                <el-date-picker size="small" v-model="publicSentimentInfo.getNumberTime" type="date" placeholder="选择日期"
                                                value-format="yyyy-MM-dd"></el-date-picker>
                            </el-descriptions-item>
                            <el-descriptions-item label="电话号码or微信">
                                <el-input size="small" v-model="publicSentimentInfo.number" placeholder="请输入"></el-input>
                            </el-descriptions-item>
                            <el-descriptions-item label="跟进状态">
                                {{publicSentimentInfo.isDeleteNote}}
                            </el-descriptions-item>
                            <el-descriptions-item label="删帖日期">
                                {{publicSentimentInfo.deleteNoteTime}}
                                <!--                            <el-date-picker size="small" v-model="publicSentimentInfo.deleteNoteTime" type="date" placeholder="选择日期"-->
                                <!--                                            value-format="yyyy-MM-dd"></el-date-picker>-->
                            </el-descriptions-item>
                        </el-descriptions>

                    </div>
                </el-tab-pane>
                <el-tab-pane label="跟进记录">
                    <div class="scroll-tab-wrap">
                        <div style="margin-bottom: 10px">
                            <el-button type="warning" size="mini" @click="()=>addRecord({})">新增跟进记录</el-button>
                        </div>
                        <template v-if="RecordList.length > 0">
                            <el-table border size="mini" :data="RecordList" style="width: 100%">
                                <el-table-column prop="chargePerson" label="负责伙伴"></el-table-column>
                                <el-table-column prop="linkType" label="联系方式"></el-table-column>
                                <el-table-column prop="messageTime" width="120" label="留言时间"></el-table-column>
                                <el-table-column prop="replyTime" width="120" label="回复时间"></el-table-column>
                                <el-table-column prop="isDeleteNote" label="跟进状态"></el-table-column>
                                <el-table-column prop="deleteNoteTime" width="120" label="删帖日期"></el-table-column>
                                <el-table-column prop="createPerson" width="120" label="创建人"></el-table-column>
                                <el-table-column prop="createTime" width="140" label="更新时间"></el-table-column>
                                <el-table-column prop="remark" label="备注"></el-table-column>
                                <el-table-column label="操作" fixed="right" width="50">
                                    <template slot-scope="scope">
                                        <el-button style="margin-right: 8px"  type="success" plain size="mini" icon="el-icon-edit" circle @click="addRecord(scope.row)"></el-button>
                                        <!--                                    <el-popconfirm-->
                                        <!--                                        title="确定要删除这条数据吗？"-->
                                        <!--                                        @confirm="delWorkOrder(scope.row.id)">-->
                                        <!--                                        <el-button type="danger" slot="reference"  plain size="mini" icon="el-icon-delete" circle></el-button>-->
                                        <!--                                    </el-popconfirm>-->
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                        <el-empty v-else :image-size="100" description="暂无信息"></el-empty>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <el-drawer  :visible.sync="addRecordDetailVisible"
                    size="80%"
                    title="新增/编辑跟踪记录"
                    :before-close="handleClose">
            <el-form ref="form" :model="formData" label-width="120px" class="draw-box">
                <el-form-item label="联系方式" required>
                    <el-select  clearable :disabled="!editRecordAble" style="width: 100%" v-model="formData.linkType" placeholder="请选择">
                        <el-option
                            v-for="item in dictionaryList.linkType||[]"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="负责伙伴" required>
                    <el-select  clearable :disabled="!editRecordAble" filterable style="width: 100%" v-model="formData.chargePerson" placeholder="请选择">
                        <el-option
                            v-for="item in userList"
                            :key="item.USER_NAME"
                            :label="item.USER_NAME"
                            :value="item.USER_NAME">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="客服留言时间">
                    <el-date-picker :disabled="!editRecordAble" size="small" v-model="formData.messageTime" type="date" placeholder="选择日期"
                                    value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
                <el-form-item label="用户回复时间">
                    <el-date-picker size="small" v-model="formData.replyTime" type="date" placeholder="选择日期"
                                    value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
                <el-form-item label="跟进状态" required>
                    <el-select  clearable :disabled="!editRecordAble" filterable size="small" style="width: 100%" v-model="formData.isDeleteNote" placeholder="请选择">
                        <el-option
                            v-for="item in dictionaryList.isDeleteNote||[]"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="删帖时间">
                    <el-date-picker :disabled="!editRecordAble" size="small" v-model="formData.deleteNoteTime" type="date" placeholder="选择日期"
                                    value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input
                        type="textarea" v-model="formData.remark" placeholder="请输入" :rows="2"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="handleRecordSubmit">立即保存</el-button>
                </el-form-item>
            </el-form>
        </el-drawer>
    </defaultSec>
</template>

<script>
import defaultSec from '@c/defaultSection'
export default {
    data() {
        return {
            loading:false,
            resourceUrl: process.env.VUE_APP_API_PATH,
            orderDetailInfo:{},
            publicSentimentInfo:{},
            formData:{},
            sentimentId: this.$route.params.id||0,
            userList:[],
            deptList:[],
            dictionaryList:{
                source:[],
                questionType:[],
                isGetNumber:[],
                isDeleteNote:[],
            },
            fileList:[],
            workOrderProductList:[],
            isWeixinOrder: true,
            editAble:this.$route.query.editAble?true:false,
            addRecordDetailVisible:false,
            handleWorkType:'',
            handleTitle:'舆情',
            logList: [],
            multipleSelProList: [],
            workResultList: [],
            RecordList: [],
            pasteImg:"",
            columnsCount:2,
            clientWidth:document.body.clientWidth,
            labelStyle:{
                width: '100px',
            },
            XhsLoading:false,
            editRecordAble:true
            // contentStyle:{
            //     width: 'calc(100% - 100px)',
            // },

        }
    },
    components:{
        defaultSec,
    },
    mounted(){
        console.log(this.$route)
        if(this.clientWidth<500){
            this.columnsCount = 1
        }else{
            this.columnsCount = 2
        }
        window.onresize = ()=>{
            console.log(5)
            this.clientWidth =document.body.clientWidth
            if(this.clientWidth<500){
                this.columnsCount = 1
            }else{
                this.columnsCount = 2
            }
        }
        if(this.$route.params.id!=0){
            this.loading = true
            this.initList()
            this.initRecordList()
        }else{

        }
        this.initUserList()
        this.initDictionaryList()

    },
    methods: {
        initList() {
            this.loading = true
            this.$apiGet('lechun-csms/xhs/getPublicSentimentById',{id: this.$route.params.id}).then(res => {
                this.loading = false
                // res.commentList = "[{\"date\":\"05-10江苏\",\"replyCount\":\"8\",\"likeCount\":\"赞\",\"replyList\":[{\"date\":\"05-11河北\",\"replyCount\":\"回复\",\"likeCount\":\"赞\",\"avatar\":\"/user/profile/5eeff653000000000101da2c?channel_type=web_note_detail_r10&xsec_token=AB8zNo7x1XOubAR2e31sQQQ0hzXOQB6Ci2sTPQt3Fgd3c%3D&xsec_source=pc_comment\",\"userName\":\"鸡肉面包\",\"content\":\"你有没有试过这个渣子一样\"}],\"avatar\":\"/user/profile/63295b08000000002303e133?channel_type=web_note_detail_r10&xsec_token=ABMdplnACJWVLVv3bMx1nd9rrPNTr8Q_YRny9_IhTD07g%3D&xsec_source=pc_comment\",\"userName\":\"momo\",\"content\":\"希腊酸奶就是这样的口味但是优点是健康！你可以加一些蓝莓草莓啥的水果（市面上大部分甜一些的好喝的酸奶都会选择添加白砂糖，因为不加糖的酸奶真不好吃）\"},{\"date\":\"05-10湖北\",\"replyCount\":\"1\",\"likeCount\":\"赞\",\"replyList\":[{\"date\":\"7 天前河南\",\"replyCount\":\"回复\",\"likeCount\":\"赞\",\"avatar\":\"/user/profile/60f413c4000000000101c11e?channel_type=web_note_detail_r10&xsec_token=ABLQv1Hi8pHwagR22E_gATt3lRDoYT0Dsu8pHEHQjmHyU%3D&xsec_source=pc_comment\",\"userName\":\"乐纯用户体验官\",\"content\":\"非常抱歉呢，这款酸奶是比较浓稠的，口感没那么丝滑呢，亲亲可以看下咱们家之前的希腊酸奶大师装，是很绵密丝滑的口感哦\"}],\"avatar\":\"/user/profile/5a992b2e11be104001bad186?channel_type=web_note_detail_r10&xsec_token=AB7bftqCjTfpcfI_MUAcH3la8Gxocg9N1gYMiMw1jqhU8%3D&xsec_source=pc_comment\",\"userName\":\"Camille\",\"content\":\"吃的我犯恶心\"},{\"date\":\"7 天前河南\",\"replyCount\":\"回复\",\"likeCount\":\"赞\",\"avatar\":\"/user/profile/60f413c4000000000101c11e?channel_type=web_note_detail_r10&xsec_token=ABLQv1Hi8pHwagR22E_gATt3lRDoYT0Dsu8pHEHQjmHyU%3D&xsec_source=pc_comment\",\"userName\":\"乐纯用户体验官\",\"content\":\"您看是否可以看下小红书私信联系咱们做下回访呢\"},{\"date\":\"05-11北京\",\"replyCount\":\"回复\",\"likeCount\":\"赞\",\"avatar\":\"/user/profile/59d0d143de5fb402e212b518?channel_type=web_note_detail_r10&xsec_token=ABtHx772yCeSIqJ8yMK4Qv-zmZNWReGW2FsjfjjphBwvs%3D&xsec_source=pc_comment\",\"userName\":\"大头有点愁。\",\"content\":\"它家是真的不好吃！！山姆和吾岛的没那么难吃\"},{\"date\":\"05-11江苏\",\"replyCount\":\"回复\",\"likeCount\":\"赞\",\"avatar\":\"/user/profile/5be12ad21e84f90001134d74?channel_type=web_note_detail_r10&xsec_token=AB-7gUBhVaYr4OIj3JhKw7xnWlRZkhGXEbVK9jmYRZQbg%3D&xsec_source=pc_comment\",\"userName\":\"贪吃的小白兔🍓\",\"content\":\"我还是最爱吾岛的黑桶和灰桶\"},{\"date\":\"05-10河南\",\"replyCount\":\"回复\",\"likeCount\":\"赞\",\"avatar\":\"/user/profile/60731a040000000001007d9b?channel_type=web_note_detail_r10&xsec_token=ABxnaYfSyuGQgxN_14RwIS0TkzUDiwAh766VTysqe7ZsI%3D&xsec_source=pc_comment\",\"userName\":\"乐纯中国体验官\",\"content\":\"很抱歉带来了不好的购物体验，作为品牌售后保障的一部分，您遇到的这个问题我们会跟进到底，确保妥善处理直到满意。您看下小红书私信，我们用户体验负责人会与您联系沟通了解具体情况，并建立专项售后项目，跟进到底。\"}]"
                let commentList = []
                try{
                    commentList = JSON.parse(res.commentList)
                }catch (e){
                    commentList = []
                }
                console.log(11,commentList)
                this.publicSentimentInfo = {...res,commentList}

            });
        },
        getShortDetail(){
            this.XhsLoading = true
            this.$apiGet('lechun-webdata/xhs/getXhsNoteContent',{ url:this.publicSentimentInfo.shortUrl, withChromeDriver:process.env.NODE_ENV == 'production'?1:0}).then(res => {
                console.log(res)
                this.XhsLoading = false

                if(res.downError){
                    console.log(1212,res.downError)
                    this.publicSentimentInfo.isDeleteNote = '已删帖'
                    this.publicSentimentInfo.deleteNoteTime = res.getNoteTime
                }else{
                    let commentList = JSON.parse(res.commentList)
                    this.publicSentimentInfo = {...this.publicSentimentInfo,...res,commentList}
                }
                this.publicSentimentSubmit('getDetail')

            }).catch(err=>{
                this.XhsLoading = false
            })
        },
        initUserList() {
            this.$apiGet('lechun-baseservice/user/getUserListForDorpbox',{}).then(res => {
                console.log(res)
                this.userList = res

            })
        },
        initDictionaryList() {
            this.$apiGet('lechun-csms/xhs/getDictionaryList',{}).then(res => {
                console.log(res)
                this.dictionaryList = res
            })
        },
        initRecordList(from) {
            this.$apiGet('lechun-csms/xhs/getRecordList',{ sentimentId: this.sentimentId}).then(res => {
                console.log(res)
                this.RecordList = res
                if(from=='save'){
                    this.publicSentimentInfo.isDeleteNote  = res.length>0?res[res.length-1].isDeleteNote:''
                }
            })
        },
        publicSentimentSubmit(from){
            let param = {...this.publicSentimentInfo}
            param.commentList = JSON.stringify(param.commentList)
            this.$apiPost('lechun-csms/xhs/savePublicSentiment', {...param}).then(res => {
                console.log(res)
                this.$message({
                    message: '保存成功',
                    type: 'success',
                    onClose: () => {
                        if(from!=='getDetail'){
                            this.$router.history.go(-1)
                        }

                    }
                });
            })
        },
        handleClose(){
            this.addRecordDetailVisible = false;
            this.formData = {}
        },
        returnPage() {
            window.history.go(-1)
            // this.$router.push({
            //     name: 'workOrderList'
            // })
        },
        handleRecordSubmit(){
            let param = {...this.formData}
            console.log('param',param)
            this.$apiPost('lechun-csms/xhs/saveRecord',param).then(res => {
                console.log(res)
                this.$message({
                    message: '成功',
                    type: 'success'
                });
                this.handleClose()
                this.initRecordList('save')
            })
        },
        openBlank(url){
            window.open(url,'_blank', 'noopener=yes,noreferrer=yes')
        },
        addRecord(item){
            this.formData = {sentimentId:this.sentimentId,...item}
            this.editRecordAble = item.id?false:true
            this.addRecordDetailVisible = true;
        }

    }
}
</script>


<style lang="scss">
.public-sentiment-detail {

    .scroll-tab-wrap{
        height: calc(100vh - 218px);
        overflow-y: scroll;
    }
    .box-card{
        margin-bottom: 20px;
    }
    .el-card__header {
        padding: 10px;
    }

    .el-card__body {
        padding: 0 10px 20px;
    }

    .popover-title {
        margin: 0 0 15px 0;
    }

    .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 100%;
    }

    .el-tag {
        margin-right: 10px;
    }
    .el-divider__text {
        color: #209e91;
    }
    .paste-wrap{
        width: 100px;
        height: 80px;
        border: 1px dashed #209e91;
        text-align: center;
        line-height: 80px;
    }
    .img-div{
        img{
            width: 12px;
            height: 12px;
            position: relative;
            top: 1px;
        }
    }
    .comment-item{
        display: flex;
        margin-bottom: 10px;
        color: #999999;
        .item-avatar{
            flex-shrink: 0;
            margin-right: 10px;
        }
        .item-wrap{
            flex: 1;
            span{
                margin-right: 8px;
                color: #333333;
            }
        }
        .item-content{
            color: #333333;
            margin: 3px 0 7px;
        }
    }
}
</style>
